import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { Spinner } from "@heroui/react";

const PrivateRoute = ({ Component }) => {
  const { auth } = useContext(AuthContext);
  const { loading } = auth;

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="lg" color="current" className="text-muted" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!auth?.data || !auth?.data?.verified) {
    return <Navigate to="/login" replace />;
  }

  // Render protected component if authenticated
  return <Component />;
};

export default PrivateRoute;
